import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { QUERY_KEYS } from '@hero/constants';

import { services } from '../../services';

export const useGetRecognition = ({ recognitionCode } = {}, options = {}) => {
  const { includeGoLiveChecks, ...queryOptions } = options;

  const goLiveQuery = useQuery(
    [QUERY_KEYS.useGetRecognitionsApprovalKey, recognitionCode],
    () => services.goLiveFlags(recognitionCode),
    {
      enabled: !!recognitionCode && includeGoLiveChecks
    }
  );

  const recognitionQuery = useQuery(
    [QUERY_KEYS.useGetRecognitionKey, recognitionCode],
    () => services.detail(recognitionCode),
    {
      enabled: !!recognitionCode,
      ...queryOptions
    }
  );

  return useMemo(() => {
    if (includeGoLiveChecks) {
      if (recognitionQuery?.data && goLiveQuery?.data) {
        recognitionQuery.data.approval = goLiveQuery.data;
      }

      return {
        ...recognitionQuery,
        data: recognitionQuery?.data,
        refetch: () => {
          recognitionQuery.refetch();
          goLiveQuery.refetch();
        },
        isFetched: recognitionQuery.isFetched && goLiveQuery.isFetched,
        isFetching: recognitionQuery.isFetching || goLiveQuery.isFetching,
        isLoading: recognitionQuery.isLoading || goLiveQuery.isLoading
      };
    }

    return recognitionQuery;
  }, [goLiveQuery, recognitionQuery, goLiveQuery]);
};
